import React, { FunctionComponent as FC } from 'react';
import classnames from 'classnames';
import { formatNumber, partHiddenEmail } from './utils';

import { Avatar, AvatarSizes } from '../Avatar';



export interface IPersonaEntity {
  subject: any;
  avatarSize: AvatarSizes;
  nowrap?: boolean;
  wrapInfo?: boolean;
  className?: string;
  [x: string]: any;
}

export const PersonaEntity: FC<IPersonaEntity> = ({
  subject,
  avatarSize,
  nowrap = false,
  wrapInfo = false,
  className,
  ...props
}) => {
  console.log('PersonaEntity', subject, props);
  return (
    <>
      <div
        className={classnames(
          'd-flex px-2 justify-space-between align-items-center',
          className,
          {
            'text-truncate w-95': subject.hideDetails,
            'flex-nowrap': nowrap,
            'flex-wrap': !nowrap,
          },
        )}
      >
        <Avatar
          subject={subject}
          size={avatarSize}
          className={avatarSize === AvatarSizes.XS ? 'mr-2' : 'mr-3'}
        />
        <div className={classnames('d-flex flex-nowrap', {
          'flex-column flex-wrap': wrapInfo,
        })}
        >
          <span
            className={`d-inline-block my-auto pr-3 ${
              subject.hideDetails ? 'text-truncate' : ''
            }`}
            data-cy={`${subject.value}-option-label`}
          >
            {subject.label}
          </span>
          {!subject.hideDetails && (
            <span className="text-muted pr-3">
              {!isNaN(subject.value) // eslint-disable-line
                ? partHiddenEmail(subject.email)
                : subject.value !== subject.label
                  ? formatNumber(subject.value.slice(2)) || ''
                  : ''}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

PersonaEntity.defaultProps = {};

export default PersonaEntity;
